import apiClient from "../config/apiClient";
import { API_ENDPOINTS } from "../config/endpoints";
import { handleApiError } from "../config/errorHandler";

/**
 * Fetch Agent Information
 * @returns {Promise<Object>} - Agent details from the API
 */
export const getAgentInfo = async () => {
  try {
    const response = await apiClient.post(API_ENDPOINTS.GET_AGENT_INFO);
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
